// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"3c3afcb3","267":"b0600120","442":"231deadf","619":"433a5c37","625":"47dab9e3","629":"9cfef92b","776":"491a324c","830":"e0788506","846":"55562d45","953":"e4a68968"}[chunkId] + ".chunk.js";
};